// BUG: https://www.bugs.cc/p/webm-progress-bar-problem-and-solution/

import ticker from '@/lib/ticker'
import videoAnalyzer from './videoAnalyzer'
// tslint:disable-next-line
require('!script-loader!../whammy.js')

interface IOptions {
  fps?: number
  width?: number
  onProcess?: (process: string) => void
}
interface ICommonConvertor {
  debug: boolean
  isCompatible: boolean
  resultWidth?: number
  resultHeight?: number
  start: (options: IOptions) => Promise<File>
}

const webmWhammyConvertor: ICommonConvertor = {
  debug: true,
  isCompatible: false,
  resultWidth: 0,
  resultHeight: 0,
  start: (
    { fps = 12, width = 100, onProcess = (process: string) => process } = {
      fps: 12,
      width: 100,
      onProcess: (process: string) => process,
    },
  ) => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
    const video = videoAnalyzer.video as HTMLVideoElement

    const resultWidth = Math.min(width, video.videoWidth)
    const resultWidthRatio = resultWidth / video.videoWidth
    const resultHeight = resultWidthRatio * video.videoHeight

    webmWhammyConvertor.resultWidth = resultWidth
    webmWhammyConvertor.resultHeight = resultHeight

    canvas.width = resultWidth
    canvas.height = resultHeight
    canvas.style.display = 'none'
    document.body.appendChild(canvas)

    return new Promise((resolve, reject) => {
      const canvasImages: string[] = []
      const computeFrame = () => {
        onProcess(`${((video.currentTime / video.duration) * 100).toFixed(2)}%`)
        ctx.drawImage(video, 0, 0, resultWidth, resultHeight)
        const dataUrl = canvas.toDataURL('image/webp')
        canvasImages.push(dataUrl)
      }

      video.addEventListener('play', () => {
        ticker.start(
          () => {
            if (video.paused || video.ended) {
              ticker.pause()
            }
            computeFrame()
          },
          { fps },
        )
      })

      video.addEventListener('ended', () => {
        document.body.removeChild(canvas)
        const blob = window.Whammy.fromImageArray(canvasImages, fps)
        resolve(new File([blob], `${videoAnalyzer.fileName}.webm`, {
          type: blob.type,
        }))
      })

      video.play()
    })
  },
}
const detect = () => {
  try {
    webmWhammyConvertor.isCompatible =
      document
        .createElement('canvas')
        .toDataURL('image/webp', 0.5)
        .indexOf('data:image/webp') === 0
  } catch (err) {
    webmWhammyConvertor.isCompatible = false
  }
}

detect()

export default webmWhammyConvertor
